import React from 'react';
import './CryptoPopUp.css';

const CryptoPaymentSubmittedPopUp = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-box">
                <button className="modal-close" onClick={onClose}>&times;</button>

                {/* Content */}
                <div className='modal-content'>
                    <h3 class="text-red text-center">! CRITICAL.</h3>
                    <p class=" ">*TXC now requires a valid <b><u>TXC Coin Wallet Address</u></b> during your account setup. Of course, you would also need this Wallet for your <u>daily crypto deposits</u>.   To complete this critical task, please follow the simple steps;</p>
                    {/* <img src="https://viron.network/member/assets/exodus.png" alt="Exodus Logo" className='exodus' />
                    <p className='mb-0'>With Exodus;</p> */}
                    <div class="list">
                        <ol class="custom-number-list mt-0 main-ul">
                            <li>Please download the <b>TEXITcoin (TXC) Wallet</b> from the App Store (iPhone) or Google Play (Android) which looks like the following; <br />
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><img src="https://viron.network/member/assets/txcWallet.png" alt="txcWallet" className='txcWallet mt-10' /></div>
                            </li>

                            <li>
                                In your VIRON back-office, go to: <u>“Edit Your Account Information”</u> that is located on your <u>left sidebar</u> as follows; <br />
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><img src="https://viron.network/member/assets/EditYourAccountGuide.png" alt="EditYourAccountGuide" className='EditYourAccountGuide mt-10' /></div>
                            </li>

                            <li>
                                <i>Enter</i> your <u className='text-red'>TXC COIN WALLET ADDRESS</u> in the following field;
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><img src="https://viron.network/member/assets/EditYourAccountFormGuide.png" alt="EditYourAccountFormGuide" className='EditYourAccountFormGuide' /></div>
                            </li>
                        </ol>
                    </div>
                    {/* <img src="https://viron.network/member/assets/buy-and-sell-directly-in-your-wallet.png" alt="buy-and-sell-directly-in-your-wallet" className='buysell' /> */}
                </div>
            </div>
        </div>
    );
};

export default CryptoPaymentSubmittedPopUp;
